<template>
    <div>
        <rkm-area
            type="fieldset"
            title="Filtros"
        >
            <rkm-form ref="Form">
                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-date-picker
                            range
                            :range-inline="false"
                            start-label="Período de"
                            end-label="Até"
                            v-model="model.periodo"
                            :start-validations="validations.periodo.start"
                            :end-validations="validations.periodo.end"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="agendamentoExame"
                            label="Exame"
                            show-default-option
                            text-field="nome"
                            v-model="model.exameId"
                            value-field="id"
                            default-option-text="Todos"
                            @change="handleExame()"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="unidadeSolicitante"
                            label="Unidade solicitante"
                            show-default-option
                            text-field="nomeFantasia"
                            v-model="model.unidadeId"
                            value-field="unidadeId"
                            default-option-text="Todas"
                            @change="handleUnidadeSolicitante()"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            label="Local de atendimento"
                            :options="infraestruturas"
                            textField="nome"
                            v-model="model.infraestruturaId"
                            valueField="id"
                            default-option-text="Todos"
                            show-default-option
                            @change="handleUnidadeSolicitante()"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row class="flex-nowrap">
                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="unidadeLaboratorio"
                            label="Laboratório"
                            show-default-option
                            text-field="nomeFantasia"
                            v-model="model.laboratorioId"
                            default-option-text="Todos"
                            value-field="unidadeId"
                            @change="loadFields()"
                        />
                    </rkm-col>

                    <rkm-col class="flex-grow-1">
                        <rkm-form-select
                            label="Local de atendimento"
                            :options="laboratorioInfraestruturas"
                            textField="nome"
                            v-model="model.laboratorioInfraestruturaId"
                            valueField="id"
                            default-option-text="Todos"
                            show-default-option
                            @change="loadFields()"
                        />
                    </rkm-col>

                    <rkm-col cols="auto">
                        <rkm-button
                            :label="false"
                            color="primary"
                            @click="$refs.Form.validate(search)"
                            :disabled="agendamentoExame.length === 0"
                        >
                            Buscar
                        </rkm-button>

                        <rkm-button
                            :label="false"
                            @click="resetForm()"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <rkm-area
            v-if="itemsNotSave.length > 0"
            no-margin-top
            title="Resultado"
        >
            <template v-slot:trailing>
                <rkm-button
                    @click="print"
                    color="info"
                    small
                    title="Imprimir"
                    :disabled="itemsNotSave.length === 0"
                >
                    <rkm-icon icon="print" />
                </rkm-button>

                <rkm-button
                    :disabled="itemsNotSave.length === 0"
                    @click="exportTo"
                    color="info"
                    small
                    title="Exportar"
                >
                    <rkm-icon icon="file-export" />
                </rkm-button>
            </template>
        </rkm-area>

        <template>
            <rkm-table
                v-if="itemsNotSave.length > 0"
                :items="itemsNotSave"
                :fields="fields"
                hide-filters
                sort-by="nome"
                hide-pagination
            >
                <template v-slot:cell(valorDefinido)="row">
                    {{ row.item.valorDefinido === '0.00' ? '-' : `R$ ${getDefinido(row.item)}` }}
                </template>

                <template v-slot:cell(valorUtilizado)="row">
                    {{ row.item.valorUtilizado === '0.00' ? '-' : `R$ ${getUtilizado(row.item)}` }}
                </template>

                <template v-slot:cell(quantidadeDefinida)="row">
                    {{ row.item.quantidadeDefinida === null ? '-' : row.item.quantidadeDefinida }}
                </template>

                <template v-slot:cell(quantidadeUtilizada)="row">
                    {{ row.item.quantidadeDefinida === null ? '-' : row.item.quantidadeUtilizada }}
                </template>
            </rkm-table>
        </template>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import { repository, error, object, formats, data, stringCase, file } from '@/mixins'

// Moment.
import moment from 'moment'

// Enums.
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'

// Filters.
import format from '@/filters/formats'

export default {
    computed: {
        optionalColumns() {

            return this.columns.filter(c => !(c.fixed || false))
        },
        fields() {

            return this.columns.filter(c => (c.fixed || false) || this.selectedCols.includes(c.key))
        },
        validations() {

            return {
                periodo: {
                    start: { required: true },
                    end: { required: true },
                },
            }
        },
        infraestruturas() {

            if (this.model.unidadeId) {

                let infraestruturaPrincipal = this.unidadeSolicitante.find(u => u.unidadeId == this.model.unidadeId).infraestruturas

                return infraestruturaPrincipal
            }

            return []
        },
        laboratorioInfraestruturas() {

            if (this.model.laboratorioId) {

                let infraestruturaPrincipal = this.unidadeLaboratorio.find(u => u.unidadeId == this.model.laboratorioId).infraestruturas

                return infraestruturaPrincipal
            }

            return []
        },
    },
    created() {

        this.repositories = {
            exame: this.getConectaSusRepository('exameLaboratorial.relatorioCotaConsumo'),
            impressao: this.getConectaSusRepository('impressao.exameLaboratorial'),
            exportacao: this.getConectaSusRepository('exportacao.exameLaboratorial'),
        },

        this.load();
    },
    data() {
        return {
            model: {
                unidadeId: null,
                infraestruturaId: null,
                laboratorioId: null,
                laboratorioInfraestruturaId: null,
                exameId: null,
                exameNome: null,
                periodo: {
                    start: null,
                    end: null,
                },
            },
            agendamentoExame: [],
            unidadeSolicitante: [],
            unidadeLaboratorio: [],
            itemsNotSave: [],
            items: [],
            enums: {
                preferenciaNome
            },
            indeterminate: false,
            filterDefault: {},
            selectedAll: false,
            columns: [
                { key: 'procedimentoCodigo', label: 'Procedimento', class: 'col-min text-center', fixed: true },
                { key: 'exameNome', label: 'Exame', sortable: true, fixed: true },
                { key: 'valorDefinido', label: 'Valor definido', class: 'col-min text-center', sortable: true, fixed: true },
                { key: 'valorUtilizado', label: 'Valor utilizado', class: 'col-min text-center', sortable: true, fixed: true },
                { key: 'quantidadeDefinida', label: 'Quantidade definida', class: 'col-min text-center', sortable: true, fixed: true },
                { key: 'quantidadeUtilizada', label: 'Quantidade utilizada', class: 'col-min text-center', sortable: true, fixed: true },
            ],
            selectedCols: [],
        }
    },
    mixins: [repository, error, object, formats, data, file, stringCase],
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        sortCompare(a, b, key) {

            if (key === 'inicio' || key === 'fim') {

                const dateA = moment(a[key], 'DD/MM/YYYY HH:mm')
                const dateB = moment(b[key], 'DD/MM/YYYY HH:mm')

                if (dateA > dateB) return 1
                else if (dateA < dateB) return -1
                else return 0

            } else {

                return false
            }
        },
        load() {

            this.model.periodo = this.data.form.periodo
        },
        print() {

            this.setLoading()

            this.repositories.impressao.relatorioCotaConsumo(this.prepareDataWithColumns())
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        exportTo() {

            this.setLoading()

            this.repositories.exportacao.relatorioCotaConsumo(this.prepareDataWithColumns())
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        prepareDataWithColumns() {

            const data = this.prepareData()

            data.selectedCols = this.fields.map(f => ({
                key: this.camelToSnake(f.key),
                label: f.label,
                class: f.class
            }))

            return data
        },
        prepareData() {

            const data = this.clone(this.model)

            if (this.model.exameId) {

                data.exameNome = this.agendamentoExame.find(u => u.id == this.model.exameId).nome
            }

            if (data.unidadeId) {

                data.coletaUnidadeNome = this.unidadeSolicitante.find(u => u.unidadeId == data.unidadeId).nomeFantasia
            }

            if (data.infraestruturaId) {

                data.coletaInfraestruturaNome = this.infraestruturas.find(u => u.id == data.infraestruturaId).nome
            }

            if (data.laboratorioId) {

                data.laboratorioNome = this.unidadeLaboratorio.find(u => u.unidadeId == data.laboratorioId).nomeFantasia
            }

            if (data.laboratorioInfraestruturaId) {

                data.laboratorioInfraestruturaNome = this.laboratorioInfraestruturas.find(u => u.id == data.laboratorioInfraestruturaId).nome
            }

            this.formateDates(data.periodo, ['start', 'end'], 'YYYY-MM-DD')

            return this.camelObjectKeysToSnakeRecursive(data)
        },
        search() {

            this.setLoading()

            this.repositories.exame.list(this.getSearchParams())
                .then(({ data }) => {

                    this.loadItens(data.model.agendamentos)
                 })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getSearchParams() {

            const params = this.clone(this.model)

            this.formateDates(params.periodo, ['start', 'end'], 'YYYY-MM-DD')

            return this.camelObjectKeysToSnakeRecursive(params)
        },
        resetForm() {

            this.model.exameId = null
            this.model.unidadeId = null
            this.model.infraestruturaId = null
            this.model.laboratorioId = null
            this.model.laboratorioInfraestruturaId = null
            this.itemsNotSave = []

            this.setDefaultValues()

            this.$nextTick(() => this.$refs.Form.resetValidator())
        },
        setDefaultValues() {

            this.model.periodo.start = moment(this.data.form.dataAtual, 'DD/MM/YYYY').toDate()
            this.model.periodo.end = moment(this.data.form.dataAtual, 'DD/MM/YYYY').toDate()
        },
        setListagem() {

            this.itemsNotSave = []
        },
        selectAll(selected) {

            this.selectedCols = selected ? this.optionalColumns.filter(item => item.disabled !== true).map(c => c.key) : []
        },
        handleInfraestrutura(infraestruturaColetaPrincipal) {

            if (infraestruturaColetaPrincipal.find(u => u.principal)) {

                this.model.infraestruturaId = infraestruturaColetaPrincipal.find(u => u.principal).id
            }
        },
        handleLaboratorioInfraestrutura(infraestruturaLaboratorioPrincipal) {

            if (infraestruturaLaboratorioPrincipal.find(u => u.principal)) {

                this.model.laboratorioInfraestruturaId = infraestruturaLaboratorioPrincipal.find(u => u.principal).id
            }
        },
        setInfraestrutura() {

            this.model.infraestruturaId = null
        },
        setLaboratorioInfraestrutura() {

            this.model.laboratorioInfraestruturaId = null
        },
        loadFields() {

            this.setLoading()
            this.setListagem()

            this.repositories.exame.loadFields(this.getSearchParams())
                .then(({ data }) => {

                    this.loadUnidadeSolicitante(data.model.unidades)
                    this.loadLaboratorio(data.model.laboratorios)
                    this.loadExame(data.model.exames)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        loadUnidadeSolicitante(unidades) {

            const unidade = []

            unidades.map(infraestrutura => {

                const unidadeInserida = unidade.find(u => u.unidadeId === infraestrutura.id)

                if (unidadeInserida) {

                    let verifyUnidade = unidadeInserida.infraestruturas.find(u => u.id ===
                        infraestrutura.infraestruturaId)

                    if (!verifyUnidade) {

                        unidadeInserida.infraestruturas.push({

                            id: infraestrutura.infraestruturaId,
                            nome: infraestrutura.infraestruturaNome,
                            principal: infraestrutura.principal,
                        })
                    }
                } else {

                    unidade.push({

                        unidadeId: infraestrutura.id,
                        nomeFantasia: infraestrutura.nome,
                        infraestruturas: [
                            {
                                id: infraestrutura.infraestruturaId,
                                nome: infraestrutura.infraestruturaNome,
                                principal: infraestrutura.principal,
                            }
                        ]
                    })
                }
            })

            this.unidadeSolicitante = unidade
        },
        loadLaboratorio(laboratorios) {

            const laboratorio = []

            laboratorios.map(infraestrutura => {

                const laboratorioInserida = laboratorio.find(u => u.unidadeId === infraestrutura.id)

                if (laboratorioInserida) {

                    let verifyUnidade = laboratorioInserida.infraestruturas.find(u => u.id ===
                        infraestrutura.infraestruturaId)

                    if (!verifyUnidade) {

                        laboratorioInserida.infraestruturas.push({

                            id: infraestrutura.infraestruturaId,
                            nome: infraestrutura.infraestruturaNome,
                            principal: infraestrutura.principal,
                        })
                    }

                } else {

                    laboratorio.push({

                        unidadeId: infraestrutura.id,
                        nomeFantasia: infraestrutura.nome,
                        infraestruturas: [
                            {
                                id: infraestrutura.infraestruturaId,
                                nome: infraestrutura.infraestruturaNome,
                                principal: infraestrutura.principal,
                            }
                        ]
                    })
                }
            })

            this.unidadeLaboratorio = laboratorio
        },
        loadExame(exames) {

            const exameCadastrado = []

            exames.map(exame => {

                const exameInserido = exameCadastrado.find(u => u.id == exame.id)

                if (!exameInserido) {

                    exameCadastrado.push({

                        id: exame.id,
                        nome: exame.nome,
                    })
                }
            })

            if (exameCadastrado) {

                exameCadastrado.sort((a,b) => (a.nome > b.nome) ? 1 : ((b.nome > a.nome) ? -1 : 0));
            }

            this.agendamentoExame = exameCadastrado

            let exameSelecionado = this.agendamentoExame.find(u => u.id == this.model.exameId)

            if (!exameSelecionado) {

                this.model.exameId = null
            }
        },
        loadItens(agendamento){

            const agendamentoCadastrado = []

            agendamento.map(item => {

                const exameInserido = agendamentoCadastrado.find(u => u.exameId == item.exameId)

                if (!exameInserido) {

                    agendamentoCadastrado.push(item)
                }
            })

            if (agendamentoCadastrado) {

                agendamentoCadastrado.sort((a,b) => (a.nome > b.nome) ? 1 : ((b.nome > a.nome) ? -1 : 0));
            }

            this.itemsNotSave = agendamentoCadastrado

        },
        getDefinido(item){

            return this.formatMoney(parseFloat(item.valorDefinido), 2)
        },
        getUtilizado(item){

            return this.formatMoney(parseFloat(item.valorUtilizado), 2)
        },
        getTotalQuantidade() {

            return this.itemsNotSave.reduce((sum, element) => {

                sum = sum + Number(element.quantidade);
                return sum;
            },0)
        },
        handleUnidadeSolicitante() {

            this.model.laboratorioId = null
            this.model.laboratorioInfraestruturaId = null
            this.loadFields()
        },
        handlePeriodo() {

            this.model.exameId = null
            this.model.unidadeId = null
            this.model.infraestruturaId = null
            this.model.laboratorioId = null
            this.model.laboratorioInfraestruturaId = null
            this.loadFields()
        },
        handleExame() {

            this.model.unidadeId = null
            this.model.infraestruturaId = null
            this.model.laboratorioId = null
            this.model.laboratorioInfraestruturaId = null
            this.loadFields()
        }
    },
    filters: {
        ...format,
    },
    props: {
        data: { type: Object, required: true }
    },
    watch: {
        selectedCols(newValue) {

        this.selectedAll = newValue.length > 0
            && newValue.length == this.optionalColumns.filter(item => item.disabled !== true).length

        this.indeterminate = newValue.length > 0
            && newValue.length != this.optionalColumns.filter(item => item.disabled !== true).length
        },
        'model.periodo.start'() {

            if (this.model.periodo.start && this.model.periodo.end) {

                this.handlePeriodo()
            }
        },
        'model.periodo.end'() {

           if (this.model.periodo.start && this.model.periodo.end) {

                this.handlePeriodo()
            }
        },
        'model.unidadeId'() {

            this.setInfraestrutura()

            if (this.model.unidadeId) {

                let infraestruturaPrincipal = this.unidadeSolicitante.find(u => u.unidadeId == this.model.unidadeId).infraestruturas

                this.handleInfraestrutura(infraestruturaPrincipal)
            }
        },
        'model.laboratorioId'() {

            this.setLaboratorioInfraestrutura()

            if (this.model.laboratorioId) {

                let infraestruturaPrincipal = this.unidadeLaboratorio.find(u => u.unidadeId == this.model.laboratorioId).infraestruturas

                this.handleLaboratorioInfraestrutura(infraestruturaPrincipal)
            }
        },
    }
}
</script>

<style scoped>
.table-th {
    background: #f1f1f1;
    padding: 0 10px;
    height: 35px;
    line-height: 35px;
    font-weight: 600;
    border-top: 1px solid #dee2e6;
    border-left: 1px solid #dee2e6;
    border-right: 1px solid #dee2e6;
}
.table-td {
    background: #f1f1f1;
    padding: 0 10px;
    height: 35px;
    border-top: 1px solid #ccc;
    font-weight: 600;
}
.table-border-top {
    border-top: 0;
    height: 30px;
    padding: 0;
}
.table-agendamento >>> .col-width {
    width: 16%;
}
.coleta {
    background: #e9e9e9;
}
</style>